import React, { Fragment } from "react"
import { Table } from "react-bootstrap"

import MainRow from "./MainRow"
import ProductInTagRow from "./ProductInTagRow"

export default function ProductsTable({
	orderItems = [],
	selectedProducts = [],
	handleAddOrRemoveItems,
	}) {
	return (
		<Table responsive className="mb-3 rounded" borderless>
		<thead>
			<tr>
			<th className="text-start">Nombre</th>
			<th>C/ a Mandar (ud/s.)</th>
			<th className="quantity-available">Disponibles</th>
			<th>Medida</th>
			<th>Ver Más</th>
			</tr>
		</thead>

		<tbody>
			{orderItems.map(item => {
			const products = item?.data?.products || []
			const otherProducts = item?.data?.otherProducts || []

			const tagProducts = item?.isTag
				? products.length > 0
				? products
				: otherProducts
				: []

			return (
				<Fragment key={item?.data?._id || item?._id}>
				<MainRow
					item={item}
					isTag={tagProducts.length > 0}
					selectedProducts={selectedProducts}
					handleAddOrRemoveItems={handleAddOrRemoveItems}
				/>

				{tagProducts.map((product, i) => {
					const currentOrderSubitem = orderItems
					.find(orderItem => {
						if (!Array.isArray(orderItem?.quantityToSend)) {
						return false
						}

						return orderItem.quantityToSend.some(
						subitem => subitem?._id === product?._id
						)
					})
					?.quantityToSend?.find(
						subitem => subitem?._id === product?._id
					)

					return (
					<ProductInTagRow
						key={product?._id || i}
						product={product}
						selectedProducts={selectedProducts}
						tagProducts={tagProducts}
						i={i}
						currentOrderSubitem={currentOrderSubitem}
						item={item}
						handleAddOrRemoveItems={handleAddOrRemoveItems}
					/>
					)
				})}
				</Fragment>
			)
			})}
		</tbody>
		</Table>
	)
}